import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!url || !publishableKey) {
  throw new Error(
    'Variáveis do Supabase ausentes. Confira VITE_SUPABASE_URL e VITE_SUPABASE_PUBLISHABLE_KEY no .env.local'
  );
}

// Cliente único do Supabase para todo o app (browser).
// Segurança real vem do RLS no banco — a publishable key é pública por design.
export const supabase = createClient(url, publishableKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});
